// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sidebar-width: 256px;
  --sidebar-collapsed-width: 80px;
  --header-height: 80px;
  --content-padding: 24px;
  --transition-speed: 0.2s;
  --border-color: #e5e7eb;
  --bg-primary: #ffffff;
  --bg-secondary: #f9fafb;
  --text-primary: #111827;
  --text-secondary: #6b7280;
}

[data-theme='dark'] {
  --border-color: #374151;
  --bg-primary: #1f2937;
  --bg-secondary: #111827;
  --text-primary: #f9fafb;
  --text-secondary: #9ca3af;
}

@media (max-width: 1550px) {
  :root {
    --sidebar-width: 192px;
    --sidebar-collapsed-width: 60px;
    --content-padding: 18px;
    --header-height: 59px;
  }
}

@media (max-width: 767px) {
  :root {
    --content-padding: 16px;
    --header-height: 48px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/variables.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,+BAA+B;IAC/B,uBAAuB;IACvB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,qBAAqB;EACvB;AACF","sourcesContent":[":root {\n  --sidebar-width: 256px;\n  --sidebar-collapsed-width: 80px;\n  --header-height: 80px;\n  --content-padding: 24px;\n  --transition-speed: 0.2s;\n  --border-color: #e5e7eb;\n  --bg-primary: #ffffff;\n  --bg-secondary: #f9fafb;\n  --text-primary: #111827;\n  --text-secondary: #6b7280;\n}\n\n[data-theme='dark'] {\n  --border-color: #374151;\n  --bg-primary: #1f2937;\n  --bg-secondary: #111827;\n  --text-primary: #f9fafb;\n  --text-secondary: #9ca3af;\n}\n\n@media (max-width: 1550px) {\n  :root {\n    --sidebar-width: 192px;\n    --sidebar-collapsed-width: 60px;\n    --content-padding: 18px;\n    --header-height: 59px;\n  }\n}\n\n@media (max-width: 767px) {\n  :root {\n    --content-padding: 16px;\n    --header-height: 48px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
